import 'css-chunksrc/client/pages/planzoneMembersPage/resource/organizationalUnitSelection/styles.scss';export default {
  "organizationalUnitSelection": "_organizationalUnitSelection_v5tpf_1",
  "input": "_input_v5tpf_5",
  "openedInput": "_openedInput_v5tpf_22",
  "iconOpen": "_iconOpen_v5tpf_28",
  "iconClose": "_iconClose_v5tpf_37",
  "listRoot": "_listRoot_v5tpf_45",
  "list": "_list_v5tpf_45",
  "none": "_none_v5tpf_61",
  "selected": "_selected_v5tpf_70",
  "placeholder": "_placeholder_v5tpf_79",
  "textHidden": "_textHidden_v5tpf_83",
  "readOnly": "_readOnly_v5tpf_88",
  "compact": "_compact_v5tpf_95"
};